export default __webpack_public_path__ + "static/media/char_body_011.1ebe23db.png";